import { render, staticRenderFns } from "./FormularioFestival.vue?vue&type=template&id=3adf1d8a&scoped=true&"
import script from "./FormularioFestival.vue?vue&type=script&lang=ts&"
export * from "./FormularioFestival.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioFestival.vue?vue&type=style&index=0&id=3adf1d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf1d8a",
  null
  
)

export default component.exports